var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import {} from '@folkjs/dom/ClientRectObserver';
import { property, ReactiveElement, state, } from '@folkjs/dom/ReactiveElement';
import { findCssSelector } from '@folkjs/dom/css-selector';
import { decodeRange, encodeRange } from '@folkjs/dom/range';
import {} from '@folkjs/geometry/Vector2';
import { toDOMPrecision } from '@folkjs/geometry/utilities';
import { FolkObserver } from './folk-observer';
const pointRegex = /\:\:point\((?<x>-?([0-9]*[.])?[0-9]+),\s*(?<y>-?([0-9]*[.])?[0-9]+)\)/;
export function decodePointFromPseudoElement(str) {
    const results = pointRegex.exec(str);
    if (results === null || results.groups === undefined)
        return null;
    const { x, y } = results.groups;
    return {
        x: Number(x),
        y: Number(y),
    };
}
function encodePoint(v) {
    return `::point(${toDOMPrecision(v.x)}, ${toDOMPrecision(v.y)})`;
}
const folkObserver = new FolkObserver();
const converter = {
    fromAttribute(value) {
        if (value === null)
            return null;
        const point = decodePointFromPseudoElement(value);
        if (point)
            return point;
        const range = decodeRange(value);
        if (range)
            return range;
        return document.querySelector(value);
    },
    toAttribute(value) {
        if (value === null)
            return '';
        else if (value instanceof Element)
            return findCssSelector(value);
        else if (value instanceof Range)
            return encodeRange(value);
        else
            return encodePoint(value);
    },
};
// TODO really need to rethink this
export class FolkBaseConnection extends ReactiveElement {
    constructor() {
        super(...arguments);
        this.source = null;
        this.sourceRect = null;
        this.target = null;
        this.targetRect = null;
        this.#sourceCallback = (entry) => {
            this.sourceRect = entry.contentRect;
        };
        this.#targetCallback = (entry) => {
            this.targetRect = entry.contentRect;
        };
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.#unobserve(this.source, this.#sourceCallback);
        this.#unobserve(this.target, this.#targetCallback);
    }
    willUpdate(changedProperties) {
        if (changedProperties.has('source')) {
            const oldSource = changedProperties.get('source') || null;
            this.#unobserve(oldSource, this.#sourceCallback);
            this.#observe(this.source, this.#sourceCallback);
        }
        if (changedProperties.has('target')) {
            const oldTarget = changedProperties.get('target') || null;
            this.#unobserve(oldTarget, this.#targetCallback);
            this.#observe(this.target, this.#targetCallback);
        }
    }
    #observe(value, callback) {
        if (value === null)
            return;
        if (value instanceof Element) {
            folkObserver.observe(value, callback);
        }
        else if (value instanceof Range) {
            folkObserver.observe(value.commonAncestorContainer, callback);
        }
        else {
            callback({ target: this, contentRect: new DOMRectReadOnly(value.x, value.y, 0, 0) });
        }
    }
    #unobserve(value, callback) {
        const oldElement = value instanceof Element ? value : value instanceof Range ? value.commonAncestorContainer : null;
        if (oldElement !== null) {
            folkObserver.unobserve(oldElement, callback);
        }
    }
    #sourceCallback;
    #targetCallback;
}
__decorate([
    property({ reflect: true, converter })
], FolkBaseConnection.prototype, "source", void 0);
__decorate([
    state()
], FolkBaseConnection.prototype, "sourceRect", void 0);
__decorate([
    property({ reflect: true, converter })
], FolkBaseConnection.prototype, "target", void 0);
__decorate([
    state()
], FolkBaseConnection.prototype, "targetRect", void 0);
//# sourceMappingURL=folk-base-connection.js.map